const plausibleScript = document.getElementById("plausible")

function updateCustomProperty(name, value) {
  plausibleScript?.setAttribute("event-" + name, value)
}

export function setPlausibleUserSegment(userSegment) {
  updateCustomProperty("user-segment", userSegment)
}

export function triggerPageview() {
  trackPlausible("pageview")
}

export function triggerEvent(eventName) {
  trackPlausible(eventName)
}

// The Plausible script can be blocked (e.g. by tracking protection in Edge on
// Windows), leaving window.plausible undefined. Guard the call so analytics
// failures never break the action that triggered them.
function trackPlausible(eventName) {
  if (typeof globalThis.plausible !== "function") {
    return
  }
  try {
    globalThis.plausible(eventName)
  } catch (error) {
    console.warn("Plausible event failed", error)
  }
}
